import React, { Component } from 'react';
import { Link } from "react-scroll/modules";
import "../../../styles/Header.scss";

import headerBkg from "../../../../../assets/playspace/playspace_header_background.png";
import headerLogo from "../../../../../assets/playspace/playspace_logo.png";
import Header from "../../../../../hoc/Header/Header";

class PlayspaceHeader extends Component {

  componentDidMount() {
      // Adding our Video Player Unit
      const script = document.createElement("script");
      script.innerText = (`cnxps.cmd.push(function () {cnxps({playerId: '1564647e-0aa5-45a2-8d7a-bf9f2a1017b6'}).render('d316e8bc250e4560a05b7be8b29e1b33');});`);
      script.id = 'd316e8bc250e4560a05b7be8b29e1b33';
      const playerContainer = document.getElementsByClassName('header-content__player')[0];
      playerContainer.appendChild(script);
  }

  render() {
    return (
      <Header backgroundImage={headerBkg}>
        <div className='header-content'>
        <div className='header-content__info-container'>
            <div className='header-content__info'>
              <img className='header-content__logo' src={headerLogo} alt=""/>
              <h1 className='header-content__description'>An end-to-end video platform designed for publishers to maximize revenue and engage readers.</h1>
              <Link to="playspace-contact"
                    spy={true}
                    smooth={true}
                    className='header-content__btn'>
                Get in touch
              </Link>
            </div>
          </div>
          <div className='header-content__player-container'>
            <div className='header-content__player-background'>
              <div className='header-content__player'>
              </div>
            </div>
          </div>
        </div>
      </Header>
    )
  }
}

export default PlayspaceHeader;